<template>
  <div id="LandingRtb">
    <MainLogo />
    <Hero :formats="['webp']" src="../../../assets/landing-rtb-hero.jpg">
      <h1>{{ $t('title') }}</h1>
    </Hero>
    <Wrap class="lg">
      <Row>
        <Column :md="8">
          <!-- <FormContactRtb class="margin-top" /> -->
          <SectionExplanationRtb />
          <SectionRequirementsRtb />
        <!-- <SectionValue /> -->
        <!-- <SectionFeedbacks /> -->
        </Column>
        <Column :md="4">
          <SectionProjects
            class="margin-top"
            :isLandingLandowner="false" />
        </Column>
      </Row>
      <!-- </Wrap> -->
      <!-- <SectionFaqLandownersLanding /> -->
      <Row class="no-gutters">
        <Column :md="7">
          <FormContactRtb />
        </Column>
        <Column :md="5" class="contacts">
          <SectionContactsRtb />
        </Column>
      </Row>
      <SectionAboutSigRtb />
      <FooterRtb />
    </Wrap>

    <!-- <SectionNumbers v-if="locale === 'pl'" /> -->
  </div>
</template>

<script>
import { actions, getters } from 'views/utils'
import FooterRtb from './components/FooterRtb'
import FormContactRtb from './components/FormContactRtb'
// import FormContactLandowner from './components/FormContactLandowner'
import Hero from 'views/components/Hero'
import MainLogo from 'views/components/TopBar/MainLogo'
import SectionAboutSigRtb from './components/SectionAboutSigRtb'
import SectionContactsRtb from './components/SectionContactsRtb'
import SectionExplanationRtb from './components/SectionExplanationRtb'
import SectionProjects from './../LandingLandowners/components/SectionProjects'
import SectionRequirementsRtb from './components/SectionRequirementsRtb'

export default {
  components: {
    FooterRtb,
    FormContactRtb,
    Hero,
    MainLogo,
    SectionAboutSigRtb,
    SectionContactsRtb,
    SectionRequirementsRtb,
    SectionExplanationRtb,
    SectionProjects,
  },
  computed: getters(),
  methods: actions('FETCH_PORTFOLIO', 'SET_LOCALE'),
  beforeMount() {
    this.LOAD(this.FETCH_PORTFOLIO())
    this.SET_LOCALE('pl')
  },
}
</script>

<style lang="scss">
#LandingRtb {
  .MainLogo {
    padding: 2rem 0 0 2rem;
    position: absolute;
    z-index: 2;
  }
  .Hero {
    h1 {
      font-size: $h3;
      text-align: center;
    }
    min-height: 30vh;
    .image {
      img {
        height: 100%;
        object-position: center;
        opacity: 0.5;
      }
    }
  }
  .contacts {
    align-items: center;
    background: $grey-lighter;
    display: flex;
    justify-content: center;
  }
  .margin-top {
    margin-top: 2rem;
  }
}
</style>

<i18n>
{
  "pl": {
    "title": "Sun Investment Group kupi gotowe projekty PV"
  }
}
</i18n>
